import { Button } from "antd"
import { useEffect, useState } from "react"
import { EkoCmsGenerate } from "../EkoEndpoint"
import { getLocalStorageItem } from "../../../../Utils"
import { useDispatch } from "react-redux"
import { setselectedTab } from "../../../../Store/B2bslice"

const EkoCMS = () => {
    const [btnLoading, setBtnLoading] = useState(false)
    const dispatch = useDispatch()
    const handleGen = () => {
        setBtnLoading(true)
        const formdata = new FormData()
        formdata.append("latitude", getLocalStorageItem("latitude"))
        formdata.append("longitude", getLocalStorageItem("longitude"))
        EkoCmsGenerate(formdata).then(res => {
            if (res.status) {
                window.open(res.data.redirect_url, "_blank")
            }
        }).catch(err => console.log(err)).finally(() => setBtnLoading(false))
    }
    useEffect(() => {
        dispatch(setselectedTab("300.6"))
    }, [])
    return (
        <>
            <div className="flex justify-center items-center">
                <Button className="border-none"
                    style={{ background: "var(--primary)", color: "white" }}
                    onClick={handleGen} loading={btnLoading}>Generate CMS</Button>
            </div>
        </>
    )
}

export default EkoCMS